import React from "react";
import { ITaskTemplateInputDefinition } from "api/model/airflow-task/task-template/TaskTemplateInfo";

interface CommentConfig {
    content: string;
}

export default function InputComment (props: ITaskTemplateInputDefinition<CommentConfig>) {
    const width = props.width ?? 12;
    const content = props.options?.customConfig?.content ?? "";

    // eslint-disable-next-line react/no-danger
    return <div className={`field col-${width}`} dangerouslySetInnerHTML={{__html: content}} />
}